// extracted by mini-css-extract-plugin
export default {"pivotMenu":"styles_pivotMenu__s3inb","pivotBody":"styles_pivotBody__FP0-E","pivotItem":"styles_pivotItem__sk2Lp","label":"styles_label__xaUhK"};